<template>
  <div class="question-container">
    <h5 class="question">{{ count + ". " + question.q[$i18n.locale] }}</h5>

    <div class="more-information-container dropdown" v-if="question.details">
      <div class="more-information" @click="openModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle"
             viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
          <path
              d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
        </svg>
      </div>
      <div class="more-information">{{ $t('more_info') }}</div>
      <div class="dropdown-content">
        <div>{{ question.details[$i18n.locale] }}</div>
      </div>
    </div>

    <div class="options-container op">
      <div><label
          :class="this.$store.state.answers[this.question.id] === undefined || this.$store.state.answers[this.question.id] === '0' ? 'red radio' : 'gray radio'">
        <input type="radio" id="red" value=0 v-model="this.$store.state.answers[this.question.id]">
        <span>{{ $t('red') }}</span>
      </label>
      </div>
      <div>
        <label
            :class="this.$store.state.answers[this.question.id] === undefined || this.$store.state.answers[this.question.id] === '1' ? 'orange radio' : 'gray radio'">
          <input type="radio" id="orange" value=1 v-model="this.$store.state.answers[this.question.id]">
          <span>{{ $t('orange') }}</span>
        </label>
      </div>
      <div>
        <label
            :class="this.$store.state.answers[this.question.id] === undefined || this.$store.state.answers[this.question.id] === '2' ? 'yellow radio' : 'gray radio'">
          <input type="radio" id="yellow" value=2 v-model="this.$store.state.answers[this.question.id]">
          <span>{{ $t('yellow') }}</span>
        </label>
      </div>
      <div>
        <label
            :class="this.$store.state.answers[this.question.id] === undefined || this.$store.state.answers[this.question.id] === '3' ? 'green radio' : 'gray radio'">
          <input type="radio" id="green" value=3 v-model="this.$store.state.answers[this.question.id]">
          <span>{{ $t('green') }}</span>
        </label>

      </div>
      <label
          :class="this.$store.state.answers[this.question.id] === undefined || this.$store.state.answers[this.question.id] === '-1' ? 'other radio' : 'gray radio'">
        <input type="radio" id="no-answer" value=-1 v-model="this.$store.state.answers[this.question.id]">
        <span>{{ $t('no_answer') }}</span>
      </label>
      <div>
        <label
            :class="this.$store.state.answers[this.question.id] === undefined || this.$store.state.answers[this.question.id] === '-2' ? 'other radio' : 'gray radio'">
          <input type="radio" id="not-applicable" value=-2 v-model="this.$store.state.answers[this.question.id]">
          <span>{{ $t('not_applicable') }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Question',
  components: {},
  props: {
    question: {},
    count: null,
  },
  data() {
    return {
      isModalVisible: false,
      checkedAnswer: null,
    };
  },
  methods: {
    openModal() {
      this.isModalVisible = true;
    }
  },
}
</script>

<style scoped lang="scss">
.question {
  padding: 2.5rem 1rem 1rem 10%;
  text-align: left;
}

.options-container {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  grid-gap: 10px;
  width: 500px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  padding-bottom: 2rem;
}

.question-container {
  background-color: #f0f0f2;
  border-radius: 15px;
}

.more-information-container {
  display: flex;
  gap: 10px;
  padding-left: 10%;
  align-items: center;
}

.more-information {
  cursor: pointer;
  font-size: 0.7rem;
}

.options-container {
  display: flex;
  justify-content: center;
}

.options-container input {
  display: none;
}

.options-container label {
  margin-right: 20px;
  display: inline-block;
  cursor: pointer;
}

.op span {
  display: block;
  padding: 5px 10px 5px 5px;
  border: 2px solid #ddd;
  border-radius: 5px;
  position: relative;
  transition: all 0.25s linear;
  height: 110px;
  min-width: 145px;
  font-size: 0.75rem;
  align-items: center;
  display: flex;
  justify-content: center
}

.op span:before {
  content: '';
  position: absolute;
  left: 5px;
  top: 50%;
  -webkit-transform: translatey(-50%);
  transform: translatey(-50%);
  border-radius: 50%;
  transition: all 0.25s linear;
}

.op input:checked + span {
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.op input:checked + span {
  border-color: black;
}

.op .yellow input + span {
  background-color: #ffee65;
}

.op .red input + span {


  background-color: #fd7f6f;
}

.op .orange input + span {
  background-color: #ffb55a;
}

.op .green input + span {
  background-color: #b2e061;
}

.op .gray input + span {
  background-color: #e2e2e2;
}

.op .other input + span {
  background-color: rgba(170, 216, 231, 0.849);
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 15px 20px;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
  margin-top: 90px;
}

textarea {
  width: 60%;
  height: 70px;
}

.comment-box {
  padding-bottom: 20px;
}
</style>
